export const siteInfo = {
  name: "独家大瓜",
  slogan: "最新首发追踪 · 每日劲爆内幕持续更新",
  shortDesc: "专注独家大瓜最新爆料与首发追踪，每日更新娱乐圈、网红圈劲爆内幕。",
  intro:
    "独家大瓜是一个专注娱乐与网红圈动态的爆料追踪站。我们不满足于转述一条热搜，而是把散落的蛛丝马迹整理成清晰的时间线，标注每一条信息的可信程度，让你从事件开始发酵到实锤落地，全程看得明明白白。",
  email: "kefu@dujiadagua.com",
  tipEmail: "baoliao@dujiadagua.com",
  since: "2021",
  stats: [
    { label: "日均追踪事件", value: "36+" },
    { label: "累计爆料条目", value: "12,480" },
    { label: "首发命中率", value: "82%" },
    { label: "活跃追瓜用户", value: "56万" },
  ],
  principles: [
    {
      icon: "ri-search-eye-line",
      title: "只做首发追踪",
      desc: "第一时间捕捉动态，并向你交代信息从哪来、更新到哪一步，而不是把旧闻重新包装。",
    },
    {
      icon: "ri-scales-3-line",
      title: "可信度分级",
      desc: "每条爆料都标注「实锤 / 待证实 / 追踪中」，让你一眼分清已确认事实与仍待验证的传闻。",
    },
    {
      icon: "ri-shield-check-line",
      title: "拒绝无依据指控",
      desc: "涉及具体个人的内容一律化名处理，只叙述公开可见的行为与反应，不做无证据的定性。",
    },
    {
      icon: "ri-time-line",
      title: "时间线复盘点",
      desc: "重要事件同步更新追踪时间线，关键节点一目了然，不吃半截瓜。",
    },
  ],
  reliabilityLegend: [
    { key: "实锤", desc: "有公开可查的物料或当事方明确回应" },
    { key: "待证实", desc: "已有一定线索，但缺少决定性证据或官方回应" },
    { key: "追踪中", desc: "事件仍在发酵，站内持续跟进更新" },
  ],
  contactChannels: [
    { icon: "ri-mail-line", label: "客服邮箱", value: "kefu@dujiadagua.com" },
    { icon: "ri-megaphone-line", label: "爆料投稿", value: "baoliao@dujiadagua.com" },
    { icon: "ri-wechat-line", label: "微信公众号", value: "独家大瓜追踪" },
  ],
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "娱乐圈", to: "/topic/yule" },
  { label: "网红圈", to: "/topic/wanghong" },
  { label: "影视瓜", to: "/topic/yingshi" },
  { label: "情感瓜", to: "/topic/qinggan" },
  { label: "首发追踪", to: "/topic/shoufa" },
  { label: "关于我们", to: "/about" },
];